import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createSlots as _createSlots, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c097ef1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "baseForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {
  ref,
  watch,
  withDefaults
} from 'vue'
import { IForm } from '@/components/types'
import { ElAutocomplete, ElForm } from 'element-plus'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseForm',
  props: {
    modelValue: {},
    iForms: { default: () => [] },
    labelWidth: { default: '120px' },
    labelPosition: { default: 'left' },
    itemStyle: { default: () => ({ padding: '10px 20px' }) },
    colLayout: { default: () => ({
      xl: 8,
      lg: 8,
      md: 8,
      sm: 8,
      xs: 8
    }) }
  },
  emits: ["update:modelValue", "select", "getFilesMap"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const autocompleteRef = ref<InstanceType<typeof ElAutocomplete>>()

const formData = ref({ ...props.modelValue })
const emit = __emit

const handleSelect = (item: any) => {
  emit('select', item)
}

const handleClear = () => {
  document.activeElement.blur()
}

watch(formData, (newValue) => emit('update:modelValue', newValue), {
  deep: true
})
const formRef = ref<InstanceType<typeof ElForm>>()
const validate = (cb: (isValid: boolean | undefined) => void) => {
  formRef.value?.validate(cb)
}
__expose({
  validate
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElForm), {
      "label-position": "",
      "label-width": _ctx.labelWidth,
      ref_key: "formRef",
      ref: formRef
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_ctx.colLayout)), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "header")
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iForms, (items, index) => {
          return (_openBlock(), _createBlock(_component_el_row, { key: index }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.formItems, (item) => {
                return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                  key: item.label,
                  ref_for: true
                }, _ctx.colLayout), {
                  default: _withCtx(() => [
                    (!item.isHidden)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: item.label,
                          prop: item.field,
                          rules: item.rules,
                          style: _normalizeStyle(_ctx.itemStyle)
                        }, {
                          default: _withCtx(() => [
                            (item.type === 'input' || item.type === 'password')
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 0,
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  "show-password": item.type === 'password',
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: formData.value['isDisabled'] || item.isDisabled,
                                  maxlength: item.maxLength
                                }), {
                                  suffix: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.suffix), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "show-password", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                              : _createCommentVNode("", true),
                            (item.type === 'numberEdit')
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 1,
                                  type: "number",
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  disabled: item.isDisabled,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  maxlength: item.maxLength
                                }), {
                                  suffix: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.suffix), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "disabled", "modelValue", "onUpdate:modelValue", "maxlength"]))
                              : _createCommentVNode("", true),
                            ('number' === item.type)
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 2,
                                  type: "number",
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: formData.value['isDisabled'] || item.isDisabled,
                                  maxlength: item.maxLength
                                }), {
                                  suffix: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.suffix), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                              : _createCommentVNode("", true),
                            ('percent' === item.type)
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 3,
                                  type: "number",
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: item.isDisabled,
                                  oninput: "if(value > 100) value = 100;"
                                }), {
                                  suffix: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.suffix), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                              : _createCommentVNode("", true),
                            (item.type === 'textarea')
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 4,
                                  type: "textarea",
                                  rows: item.rows,
                                  autosize: { minRows: 2, maxRows: 6 },
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: formData.value['isDisabled'] || item.isDisabled,
                                  maxlength: item.maxLength
                                }), null, 16, ["rows", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                              : _createCommentVNode("", true),
                            (item.type === 'alltextarea')
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 5,
                                  type: "textarea",
                                  rows: item.rows,
                                  autosize: {minRows: 4, maxRows: 24},
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: formData.value['isDisabled'] || item.isDisabled,
                                  maxlength: item.maxLength
                                }), null, 16, ["rows", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "maxlength"]))
                              : _createCommentVNode("", true),
                            (item.type === 'nest')
                              ? (_openBlock(), _createBlock(_component_el_row, { key: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, { align: "middle" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, null, {
                                          default: _withCtx(() => [
                                            (!item.isHidden)
                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                  key: 0,
                                                  label: item.otherOptions.child.label,
                                                  prop: item.field,
                                                  rules: item.rules,
                                                  style: _normalizeStyle(_ctx.itemStyle)
                                                }, {
                                                  default: _withCtx(() => [
                                                    (item.otherOptions.child.type === 'select')
                                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                                          key: 0,
                                                          placeholder: item.otherOptions.child.placeholder,
                                                          modelValue: 
                                formData.value[`${item.otherOptions.child.field}`]
                              ,
                                                          "onUpdate:modelValue": ($event: any) => ((
                                formData.value[`${item.otherOptions.child.field}`]
                              ) = $event),
                                                          style: {"width":"100%"},
                                                          disabled: 
                                formData.value['isDisabled'] ||
                                item.otherOptions.child.isDisabled
                              
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.otherOptions.child
                                  .options, (option) => {
                                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                                key: option.value,
                                                                value: option.value,
                                                                label: option.title
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(option.title), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["value", "label"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label", "prop", "rules", "style"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_col, null, {
                                          default: _withCtx(() => [
                                            (!item.isHidden)
                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                  key: 0,
                                                  label: item.otherOptions.child2.label,
                                                  prop: item.field,
                                                  rules: item.rules,
                                                  style: _normalizeStyle(_ctx.itemStyle)
                                                }, {
                                                  default: _withCtx(() => [
                                                    (item.otherOptions.child2.type === 'select')
                                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                                          key: 0,
                                                          placeholder: 
                                item.otherOptions.child2.placeholder
                              ,
                                                          modelValue: 
                                formData.value[`${item.otherOptions.child2.field}`]
                              ,
                                                          "onUpdate:modelValue": ($event: any) => ((
                                formData.value[`${item.otherOptions.child2.field}`]
                              ) = $event),
                                                          style: {"width":"100%"},
                                                          disabled: 
                                formData.value['isDisabled'] ||
                                item.otherOptions.child2.isDisabled
                              
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.otherOptions.child2
                                  .options, (option) => {
                                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                                key: option.value,
                                                                value: option.value,
                                                                label: option.title
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(option.title), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["value", "label"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label", "prop", "rules", "style"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (item.type === 'autocomplete')
                              ? (_openBlock(), _createBlock(_unref(ElAutocomplete), _mergeProps({
                                  key: 7,
                                  ref_for: true
                                }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  modelValue: formData.value[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event),
                                  disabled: formData.value['isDisabled'] || item.isDisabled,
                                  onSelect: handleSelect,
                                  onClear: handleClear,
                                  ref_for: true,
                                  ref_key: "autocompleteRef",
                                  ref: autocompleteRef
                                }), null, 16, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                              : (item.type === 'select')
                                ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                    key: 8,
                                    clearable: item.clearable,
                                    ref_for: true
                                  }, item.otherOptions, {
                                    placeholder: item.placeholder,
                                    style: {"width":"100%"},
                                    disabled: formData.value['isDisabled'] || item.isDisabled,
                                    multiple: item.multiple,
                                    modelValue: formData.value[`${item.field}`],
                                    "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                  }), _createSlots({
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: option.value,
                                          value: option.value,
                                          label: option.title
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(option.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, [
                                    (item.suffix)
                                      ? {
                                          name: "prefix",
                                          fn: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.suffix), 1)
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1040, ["clearable", "placeholder", "disabled", "multiple", "modelValue", "onUpdate:modelValue"]))
                                : (item.type === 'datepicker')
                                  ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                      key: 9,
                                      style: {"width":"100%"},
                                      ref_for: true
                                    }, item.otherOptions, {
                                      disabled: formData.value['isDisabled'] || item.isDisabled,
                                      modelValue: formData.value[`${item.field}`],
                                      "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                    }), null, 16, ["disabled", "modelValue", "onUpdate:modelValue"]))
                                  : (item.type === 'cascader')
                                    ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                                        key: 10,
                                        options: item.options,
                                        ref_for: true
                                      }, item.otherOptions, {
                                        style: {"width":"100%"},
                                        placeholder: item.placeholder,
                                        disabled: formData.value['isDisabled'] || item.isDisabled,
                                        modelValue: formData.value[`${item.field}`],
                                        "onUpdate:modelValue": ($event: any) => ((formData.value[`${item.field}`]) = $event)
                                      }), null, 16, ["options", "placeholder", "disabled", "modelValue", "onUpdate:modelValue"]))
                                    : ('default' === item.type)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                          (
                      formData.value[`${item.field}`] == null &&
                      'empName' === item.field
                    )
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(_unref(store).state.login.userInfo.realName), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(formData.value[`${item.field}`]), 1)
                                              ], 64))
                                        ], 64))
                                      : ('slot' === item.type)
                                        ? _renderSlot(_ctx.$slots, "insert", { key: 12 })
                                        : ('proveSlot' === item.type)
                                          ? _renderSlot(_ctx.$slots, "proveInsert", { key: 13 })
                                          : ('fileSolt' === item.type)
                                            ? _renderSlot(_ctx.$slots, "fileInsert", { key: 14 })
                                            : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label", "prop", "rules", "style"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1040))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["label-width"]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _hoisted_2,
    _hoisted_3
  ]))
}
}

})